// extracted by extract-css-chunks-webpack-plugin
module.exports = {"header":"header___LDeib","body":"body___XpQ8r"};